import { useTranslation } from 'react-i18next';

import dayjs from 'dayjs';

import { useTradingJournalDateRange } from '../lib/use-trading-journal-date-range';

export const useCardDateRangeSubtitle = (): string => {
    const { t } = useTranslation('tradingJournal');
    const { dateRange } = useTradingJournalDateRange();

    if (!dateRange || !dateRange[0] || !dateRange[1]) {
        return t('tradingJournalAllTime');
    }

    const startDate = dayjs(dateRange[0]).format('YYYY/MM/DD');
    const endDate = dayjs(dateRange[1]).format('YYYY/MM/DD');

    if (startDate === endDate) {
        return startDate;
    }

    return `${startDate} - ${endDate}`;
};
